import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import AppRoutes from './routes/AppRoutes';
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  return (
    <BrowserRouter>
      <div style={{ paddingTop: '80px' }}>
        <ScrollToTop />
        <Navbar />
        <AppRoutes />
        <Footer />
        <BackToTop />
      </div>
    </BrowserRouter>
  );
}
